// extracted by mini-css-extract-plugin
export default {"marker":"StatusMarker_marker__UNK+q"};